import { Link } from "react-router-dom";

export const Contact = () => {
  return (
    <div className="home">
      <Link
        to={{
          pathname: "https://instagram.com/gospeldownloads",
        }}
        target="_blank"
        className="canvas"
      >
        Instagram
      </Link>
      <Link
        to={{
          pathname: "https://www.hicetnunc.xyz/gospeldownloads",
        }}
        target="_blank"
        className="canvas"
      >
        HicEtNunc
      </Link>
      <Link
        to={{
          pathname: "https://soundcloud.com/gospel144",
        }}
        target="_blank"
        className="canvas"
      >
        SoundCloud
      </Link>
      <Link
        to={{
          pathname: "https://github.com/rhamo1",
        }}
        target="_blank"
        className="canvas"
      >
        GitHub
      </Link>
      <Link
        to={{
          pathname: "https://open.spotify.com/user/rhamo1998",
        }}
        target="_blank"
        className="canvas"
      >
        Spotify
      </Link>
      <Link
        to={{
          pathname: "https://gospeldownloads.tumblr.com/",
        }}
        target="_blank"
        className="canvas"
      >
        Tumblr
      </Link>
    </div>
  );
};
